import { Box, Button, OutlinedInput, styled } from "@mui/material";
import { brighthiveTheme } from "../theme/theme";

export const PageexpiredHolder = styled(Box)`
  width: 100%;
  min-height: calc(100% - 48px);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
`;
export const Pageexpiredcontent = styled(Box)`
  border: 1px solid ${brighthiveTheme.palette.action.disabledBackground};
  padding: 0 15px 15px;
  margin: 20px 0;
  border-radius: 10px;
  max-width: 600px;
  font-size: 16px;
  line-height: 20px;
  color: ${brighthiveTheme.palette.common.black};
  overflow: hidden;
  h2 {
    font-size: 24px;
    font-weight: bold;
    border-bottom: 1px solid
      ${brighthiveTheme.palette.action.disabledBackground};
    margin: 0 -15px 15px;
    padding: 15px;
    background: rgba(103, 111, 142, 0.07);
  }
  p {
    margin: 0 0 20px;
  }
  a {
    color: ${brighthiveTheme.palette.primary.dark};
  }
`;

export const LinkHolder = styled(Box)`
  border-top: 1px solid ${brighthiveTheme.palette.action.disabledBackground};
  padding-top: 20px;
  margin-top: 20px;
  a {
    color: ${brighthiveTheme.palette.link.main};
  }
`;
